var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 42,
    fill: "#EB2019"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2732_9423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.2164 44.4851C32.9611 44.2267 32.8185 43.8778 32.8196 43.5146C32.8207 43.1514 32.9655 42.8034 33.2223 42.5465C33.4791 42.2897 33.8272 42.1449 34.1904 42.1438C34.5536 42.1427 34.9025 42.2854 35.1609 42.5406L40.625 48.0047V32.6328C40.625 32.2681 40.7699 31.9184 41.0277 31.6605C41.2856 31.4027 41.6353 31.2578 42 31.2578C42.3647 31.2578 42.7144 31.4027 42.9723 31.6605C43.2301 31.9184 43.375 32.2681 43.375 32.6328V48.0047L48.8392 42.5406C48.9664 42.4111 49.1181 42.308 49.2854 42.2374C49.4527 42.1667 49.6324 42.13 49.814 42.1291C49.9956 42.1283 50.1755 42.1635 50.3435 42.2326C50.5114 42.3018 50.664 42.4035 50.7924 42.5319C50.9208 42.6603 51.0225 42.8129 51.0917 42.9808C51.1608 43.1488 51.1959 43.3287 51.1951 43.5104C51.1943 43.692 51.1575 43.8716 51.0869 44.0389C51.0162 44.2062 50.9132 44.3579 50.7836 44.4851L42.9719 52.2964C42.714 52.5543 42.3643 52.6991 41.9997 52.6991C41.635 52.6991 41.2853 52.5543 41.0274 52.2964L33.2164 44.4851ZM64 42C64 54.1309 54.1309 64 42 64C29.8691 64 20 54.1309 20 42C20 29.8691 29.8691 20 42 20C54.1309 20 64 29.8691 64 42ZM61.25 42C61.25 31.3855 52.6145 22.75 42 22.75C31.3855 22.75 22.75 31.3855 22.75 42C22.75 52.6145 31.3855 61.25 42 61.25C52.6145 61.25 61.25 52.6145 61.25 42Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2732_9423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnergy);
export default __webpack_public_path__ + "static/media/icon-energy.7acd204e20d721de55059c6d8820fc85.svg";
export { ForwardRef as ReactComponent };